// Reopens the cookie notice — mirrors anyainow's CookiePreferencesButton.
// There's nothing to actually "change" (freeainow has one strictly-necessary
// cookie and no analytics/tracking cookies to opt in/out of), so this just
// re-shows the notice for anyone who wants to read it again.
export default function CookiePreferencesButton({ className }) {
  function reopen() {
    try {
      localStorage.removeItem("cookie_notice_dismissed");
    } catch {
      /* ignore unavailable storage */
    }
    window.dispatchEvent(new Event("reopen-cookie-banner"));
  }

  return (
    <button onClick={reopen} className={className ?? "link-btn"}>
      Click here
    </button>
  );
}
